'use client';

import React, { useEffect } from 'react';
import Checkout, { CheckoutWrappedProps } from 'components/commercetools-ui/organisms/checkout';
import CommercetoolsCheckout from 'components/commercetools-ui/organisms/checkout/ct-checkout';
import { TasticProps } from '../types';
import { useSearchParams } from 'next/navigation';
import { RedirectContainer } from 'components/commercetools-ui/organisms/checkout/components/steps/sections/payment/redirect';
// import Header from '../header';
import AmazonPayCheckout from 'components/commercetools-ui/organisms/amazonpay-checkout';

const CheckoutTastic = ({ data }: TasticProps<CheckoutWrappedProps>) => {
  //CT-Checkout
  // return <CommercetoolsCheckout {...data} />;
  const searchParams = useSearchParams();
  const amazonCheckoutSessionId = searchParams.get('amazonCheckoutSessionId');
  //Fully customized checkout
  if (amazonCheckoutSessionId) {
    return <AmazonPayCheckout {...data} amazonCheckoutSessionId={amazonCheckoutSessionId} />;
  } else {
    return <Checkout {...data} />;
  }
};

export default CheckoutTastic;
